enum MixpanelProjectToken {
  Production = "febff3a1a0875011e743a9ec6bee4dce",
  Sandbox = "60ab0efc26e87e7e3afb59543d7132d4",
}

export default MixpanelProjectToken;
